import { NavigateFunction } from "react-router-dom";
import { loginApi } from "../../services/api";
import { User } from "../context/MainContextProvider";

export default function NotAuthenticatedErrorMessage(
  navigate: NavigateFunction,
  setUser: (user: User | undefined) => void,
  pushDeviceId: string | undefined
) {
  async function logout() {
    await loginApi.logout({
      pushDeviceId: pushDeviceId || undefined,
    });

    setUser(undefined);

    navigate("/login");
  }

  return {
    logout,
  };
}
